export type TrafficSignalPhaseGroup = "axis-a" | "axis-b";

export interface TrafficSignalRenderConfig {
  readonly maximumSourceToRoadDistanceM: number;
  readonly curbClearanceM: number;
  readonly centrelineSideDeadZoneM: number;
  readonly junctionAxisToleranceM: number;
  readonly junctionSetbackM: number;
  readonly distinctAxisMaximumDot: number;
  readonly poleHeightM: number;
  readonly poleRadiusM: number;
  readonly housingWidthM: number;
  readonly housingHeightM: number;
  readonly housingDepthM: number;
  readonly lensRadiusM: number;
  readonly cycleSeconds: number;
  readonly greenSeconds: number;
  readonly amberSeconds: number;
  readonly allRedSeconds: number;
  readonly activeLensIntensity: number;
  readonly inactiveLensIntensity: number;
}

/**
 * Low-detail proportions follow the narrow dark poles and vertically stacked
 * LED heads visible in current Vilnius junction references. Geographic
 * positions come only from the separable OSM traffic-signal snapshot.
 */
export const TRAFFIC_SIGNAL_RENDER_CONFIG:
  Readonly<TrafficSignalRenderConfig> = Object.freeze({
    maximumSourceToRoadDistanceM: 14,
    curbClearanceM: 0.48,
    centrelineSideDeadZoneM: 0.35,
    junctionAxisToleranceM: 0.9,
    junctionSetbackM: 1.15,
    distinctAxisMaximumDot: 0.84,
    poleHeightM: 3.45,
    poleRadiusM: 0.065,
    housingWidthM: 0.38,
    housingHeightM: 1.02,
    housingDepthM: 0.3,
    lensRadiusM: 0.105,
    cycleSeconds: 72,
    greenSeconds: 30,
    amberSeconds: 4,
    allRedSeconds: 2,
    activeLensIntensity: 4.8,
    inactiveLensIntensity: 0.045,
  });
